/*
 * @Descripttion: 
 * @Author: qhx
 * @Date: 2025-03-07 14:08:40
 * @LastEditTime: 2025-04-25 14:22:47
 */
import React, { useState, useEffect } from "react";
import { Modal, Button } from 'antd';
import { useNavigate } from "react-router-dom";
// import DeleteModal from '../delete-modal';
// import ProcessModal from '../../payment/components/process-modal';
// import { payList,orderStatusArr } from '../../../myOrder/config';
import { deleteOrderList, confirmReceipt } from '@/api/personal-center';
import { payList } from '../../config'
import './index.scss';
import { message, Popover } from "antd";
import ApplyModal from '../apply-modal';//申请开票
import ViewModal from '../view-modal';//查看发票
import ReceiptModal from '../receipt-modal';//下载发票
import { getBill } from '@/api/my-invoice';
import { getBuyWay } from "@/utils";

interface IProps {
  orderData: any,
  setIsRefresh?: any,

}
const invoiceType: any = {
  1: '数电普通发票',
  2: '数电普通发票',
  3: '数电专用发票',
}
const OrderTableMain: React.FC<IProps> = (props) => {
  const {
    orderData,
    setIsRefresh,
  } = props;
  const [showApplyModal, setShowApplyModal] = useState(false);//申请开票
  // const [applyTimes,setApplyTimes] = useState(0); // 申请次数
  const [showViewModal, setShowViewModal] = useState(false);
  const [showReceiptModal, setShowReceiptModal] = useState(false);
  const [orderId, setOrderId] = useState<number>(0);
  const [isChange, setIsChange] = useState<number>(1);// 修改申请，掉接口不同，做不同的标记1:第一次，2：修改
  const [id,setId] = useState<number>(0);
  const [billId, setBillId] = useState<number>(0);
  // useEffect(() => { 
  //   setIsRefresh(true);
  // },[showApplyModal])

  // 查看发票基本信息
  const handleReceiptInfo = (orderId: number,id:number,billId:number) => {
    setOrderId(orderId);
    setId(id);
    setBillId(billId);
    setShowViewModal(true);
  }
  // 查看发票
  const handleViewReceipt = (id: number) => {
    // setOrderId(id);
    // setShowReceiptModal(true);
    getBill(id).then((res: any) => {
      if (res.success) {
        // setReceiptUrl(res.obj?.showUrl);
       window.open(res.obj?.showUrl, '_blank');
        
      } else {
        message.error(res.message);
      }
    })
  
  }
  // 下载发票
  const handleDownloadReceipt = (id: number) => {
    window.location.href = `${window.location.origin}/attachCenter/invoice/downloadBill.json?orderId=${id}`
    // window.location.href=`http://mall.originqc.com/attachCenter/invoice/downloadBill.json?orderId=${id}`
    //  setOrderId(id);
    //  setShowReceiptModal(true);
  }
  const handleApplyReceipt = (orderId: number,id:number,billId:number) => {
    setOrderId(orderId);
    setId(id);
    setBillId(billId);
    setShowApplyModal(true);
  }
  return (
    <>
      <div className="invoice-table-main">
        {
          orderData.map((oData: any) => (
            <div className="order-detail" key={oData.id}>
              <p>申请开票时间：{oData.applyTime}&nbsp;&nbsp; 订单号：{oData.orderNo}</p>
              <div className="order-table">
                <div className="order-product">
                  {
                    oData.productList.map((pData: any) => (
                      <div className="order-product-info" key={pData.id}>
                        <div
                          style={{ width: 310 }}
                          className="style-inset inset-name"
                          title={pData.productName}
                        >
                          <img
                            src={pData?.showPics && JSON.parse(pData?.showPics)}
                            alt=''
                            onClick={() => window.open(`/detail?productSn=${pData.productSn}`)} />
                          <div className="order-info-detail">
                            <span
                              onClick={() => window.open(`/detail?productSn=${pData.productSn}`)}>
                              {pData.productName}
                            </span>
                            <span className="order-modal">
                              {pData.modelName} { pData?.unit&&getBuyWay(pData?.unit)}
                            </span>
                          </div>
                        </div>

                      </div>
                    ))
                  }
                </div>

                <div className="order-operate" style={{ height: 120 * oData.productList.length }}>
                  <div
                    style={{ width: 81 }}
                    className="style-inset">¥{oData.amount}</div>
                  <div
                    style={{ width: 101 }}
                    className="style-inset">
                    {invoiceType[oData.type]}
                  </div>
                  <div
                    style={{ width: 111 }}
                    className="style-inset invoice-header"
                    title={oData.type === 1 ? '个人-' + oData.header : '企业-' + oData.header}>
                    <span className="invoice-header-detail">{oData.type === 1 ? '个人-' : '企业-'}{oData.header}</span>
                  </div>
                  <div style={{ width: 100 }} className="style-inset">
                    {/* {(payList.find((ele: any) => ele.value === oData.payType))?.label ?? '-'} */}
                    {oData.status === 4?'-':oData.approveTime?.slice(0, 10)}
                  </div>
                  <div style={{ width: 101 }} className="style-inset status-detail">
                    <span 
                    className={`status color-${oData.status}`}>
                      {(payList.find((ele: any) => ele.value === oData.status))?.label ?? '-'}
                    </span>

                    {oData.status === 4 && <Popover content={oData?.reason} title="拒绝原因">
                      <span className="reason">拒绝原因</span>
                    </Popover>}
                  </div>
                  <div style={{ width: 110 }} className="style-inset order-btn">
                    {
                      (oData.status === 1) &&
                      <>
                        <span onClick={() => handleReceiptInfo(oData.orderId,oData.id,oData.billId)}>查看开票信息</span>

                      </>
                    }
                    {/* {
                      oData.status === 4 &&
                      <span onClick={()=>orderDeleteDialog(oData.id)}>删除订单</span>
                    } */}
                    {
                      (oData.status === 3) &&
                      <>
                        <span onClick={() => handleViewReceipt(oData.orderId)}>查看发票</span>
                        <span onClick={() => handleDownloadReceipt(oData.orderId)}>下载发票</span>
                      </>
                    }
                    {
                      (oData.status === 4) && <span onClick={() => handleApplyReceipt(oData.orderId,oData.id,oData.billId)}>申请开票</span>
                    }
                  </div>
                </div>
              </div>
            </div>
          ))
        }

      </div>
      <ApplyModal
        showApplyModal={showApplyModal}
        setShowApplyModal={setShowApplyModal}
        orderId={orderId}
        isChange={isChange}
        id={id}
        billId={billId}
        setIsRefresh={ setIsRefresh}
      />
      <ViewModal
        showViewModal={showViewModal}
        setShowViewModal={setShowViewModal}
        setShowApplyModal={setShowApplyModal}
        orderId={orderId}
        id={id}
        setIsChange={ setIsChange}
      />
      <ReceiptModal
        showReceiptModal={showReceiptModal}
        setShowReceiptModal={setShowReceiptModal}
        orderId={orderId}
      />
    </>
  )
}

export default OrderTableMain;